const state = () => ({
    unconfirmedAlarmCount : 0,
    unconfirmedAsReceiptCount : 0,
});

const getters = {
    getUnconfirmedAlarmCount: state => state.unconfirmedAlarmCount,
    getUnconfirmedAsReceiptCount: state => state.unconfirmedAsReceiptCount,
};

const actions = {
    setUnconfirmedAlarmCount({ commit }, data) {
        commit('SET_UNCOMFIRMED_ALARM_COUNT' , data);
    },
	setUnconfirmedAsReceiptCount({ commit }, data) {
        commit('SET_UNCOMFIRMED_AS_RECEIPT_COUNT' , data);
    },
};

const mutations = {
	SET_UNCOMFIRMED_ALARM_COUNT(state, payload) {
		state.unconfirmedAlarmCount = payload;
	},    
	SET_UNCOMFIRMED_AS_RECEIPT_COUNT(state, payload) {
		state.unconfirmedAsReceiptCount = payload;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
